import { isArray, isNil } from 'lodash';

export const PARTICIPANTS_TAG = 'Participants';

export const SET_PARTICIPANT = 'SET_PARTICIPANT';
export const SET_SEARCH_MESSAGE = 'SET_SEARCH_MESSAGE';

export const EMPTY_PARTICIPANT = {
  sex: '-',
  age: '-',
  email: '',
  id: null
};

/**
 *
 * @param {*} email
 * @return {participant}
 */
export const getParticipantByEmail = (email, callback) => {
  return async (dispatch, getState, { apiClient }) => {
    let response = {
      sex: '-',
      age: '-'
    };

    try {
      const participant = await apiClient.call(PARTICIPANTS_TAG, 'getParticipants', {
        email
      });

      if (
        !isNil(participant) &&
        isArray(participant.data) &&
        typeof participant.data[0] !== 'undefined'
      ) {
        [response] = participant.data;
      }
    } catch (e) {
      console.log('getParticipantByEmail error'); // eslint-disable-line no-console
      console.log(e); // eslint-disable-line no-console
    }

    callback && callback(response);

    return true;
  };
};

export const createParticipant = (newParticipant, callback) => {
  return async (dispatch, getState, { apiClient }) => {
    let response = {
      sex: '-',
      age: '-'
    };

    try {
      const participant = await apiClient.call(
        PARTICIPANTS_TAG,
        'createParticipant',
        {},
        {
          email: newParticipant.email,
          birthyear: newParticipant.birthyear,
          sex: newParticipant.sex,
          language: ''
        }
      );

      if (!isNil(participant)) {
        response = participant;
      }
    } catch (e) {
      console.log('createParticipant error'); // eslint-disable-line no-console
      console.log(e); // eslint-disable-line no-console
    }

    callback && callback(response);

    return true;
  };
};

export const setParticipant = participant => {
  return {
    type: SET_PARTICIPANT,
    participant
  };
};



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/data/fileImport/participantActions.js